import { FC, HTMLAttributes } from "react";
import { useStyles } from "./GemAnimation.style";
import { Image } from "@onmo/ui";
import Gem from "../../../assets/icons/gem_1x.webp";
import Gem2x from "../../../assets/icons/gem_2x.webp";
import Gem3x from "../../../assets/icons/gem_3x.webp";
import { useGemAnimation } from "../../../hooks/useGemAnimation";

interface DiamondBurstProps extends HTMLAttributes<HTMLDivElement> {
  gems: number;
}

export const GemAnimation: FC<DiamondBurstProps> = ({ gems = 0, ...props }) => {
  const classes = useStyles();
  const particles = useGemAnimation(gems);

  if (!particles || particles?.length === 0) return null;

  return (
    <div {...props} className={`${classes.container} ${props.className || ""}`}>
      {particles.map((p, idx) => (
        <div key={p.id + idx} className={classes.particle} style={p.style}>
          <Image
            src={Gem}
            src2x={Gem2x}
            src3x={Gem3x}
            style={{ width: "100%", height: "100%", display: "block" }}
            className={classes.gemIcon}
          />
        </div>
      ))}
    </div>
  );
};
